module.exports = __webpack_public_path__ + "static/assets/3fff31f5006239bc69f15e0a747bbd84.svg";